<template>
  <v-container>
    <v-select
      :items="['metres', 'miles', 'kilometres']"
      label="Distance"
      require
      v-model="selectedDistanceUnits"
    />
    <v-select
      :items="['feet', 'metres']"
      label="Elevation"
      required
      v-model="selectedElevationUnits"
    />
    <v-select :items="['m/s', 'mph', 'kph']" label="Speed" required v-model="selectedSpeedUnits"/>
  </v-container>
</template>

<script>
import clone from 'lodash/clone';

let pref = {};

export default {
  name: 'preferences',
  props: {
  },
  data: () => ({
    init: false,
    selectedDistanceUnits: null,
    selectedElevationUnits: null,
    selectedSpeedUnits: null,
  }),
  computed: {
  },
  watch: {
    selectedDistanceUnits(value) {
      this.setPreference('distance', value);
    },
    selectedElevationUnits(value) {
      this.setPreference('elevation', value);
    },
    selectedSpeedUnits(value) {
      this.setPreference('speed', value);
    },
  },
  mounted() {
    this.init = false;
    pref = clone(this.$store.getters.preferences);
    this.selectedDistanceUnits = pref.distance;
    this.selectedElevationUnits = pref.elevation;
    this.selectedSpeedUnits = pref.speed;
    this.init = true;
  },
  methods:
    {
      setPreference(name, value) {
        if (this.init && name && value) {
          pref[name] = value;
          this.$store.commit('setPreferences', pref);
        }
      },
    },
};
</script>

<style>
</style>
